function BezpecnostVPlynarenstve(){
    return(
        <div>
            Bezpecnost V Plynarenstve
        </div>
    );
};

export default BezpecnostVPlynarenstve;